import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  getDocs, 
  query, 
  where 
} from 'firebase/firestore';
import { db } from '../firebase';

// Reference to the folders collection
export const foldersRef = collection(db, 'folders');

// Create a new folder
export const createFolder = async (userId, name) => {
  try {
    const folderData = {
      name,
      userId,
      createdAt: new Date(),
      updatedAt: new Date()
    };
    
    const docRef = await addDoc(foldersRef, folderData);
    return { id: docRef.id, ...folderData };
  } catch (error) {
    console.error('Error creating folder:', error);
    throw error;
  }
};

// Get all folders for a user
export const getUserFolders = async (userId) => {
  try {
    const q = query(foldersRef, where('userId', '==', userId));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Error getting user folders:', error);
    throw error;
  }
};

// Rename a folder
export const renameFolder = async (folderId, newName) => {
  try {
    const folderRef = doc(foldersRef, folderId);
    await updateDoc(folderRef, {
      name: newName,
      updatedAt: new Date()
    });
  } catch (error) {
    console.error('Error renaming folder:', error);
    throw error;
  }
};

// Delete a folder
export const deleteFolder = async (folderId) => {
  try {
    const folderRef = doc(foldersRef, folderId);
    await deleteDoc(folderRef);
  } catch (error) {
    console.error('Error deleting folder:', error);
    throw error;
  }
};

// Move a group to a folder
export const moveGroupToFolder = async (groupName, folderId) => {
  try {
    // Find all cards in this group
    const cardsQuery = query(
      collection(db, 'cards'),
      where('groups', 'array-contains', groupName)
    );
    const snapshot = await getDocs(cardsQuery);

    // Update each card's folderId
    const updatePromises = snapshot.docs.map(cardDoc =>
      updateDoc(doc(db, 'cards', cardDoc.id), { folderId })
    );
    await Promise.all(updatePromises);
  } catch (error) {
    console.error('Error moving group to folder:', error);
    throw error;
  }
};

// Remove a group from a folder
export const removeGroupFromFolder = async (groupName) => {
  try {
    // Find all cards in this group
    const cardsQuery = query(
      collection(db, 'cards'),
      where('groups', 'array-contains', groupName)
    );
    const snapshot = await getDocs(cardsQuery);

    // Update each card's folderId to null
    const updatePromises = snapshot.docs.map(cardDoc =>
      updateDoc(doc(db, 'cards', cardDoc.id), { folderId: null })
    );
    await Promise.all(updatePromises);
  } catch (error) {
    console.error('Error removing group from folder:', error);
    throw error;
  }
}; 